module.exports = __webpack_public_path__ + "static/media/IconTemplates_-99.29e3d22a.svg";